import { render, staticRenderFns } from "./ExternalCharges.vue?vue&type=template&id=0a0cdfd4&scoped=true&"
import script from "./ExternalCharges.vue?vue&type=script&lang=js&"
export * from "./ExternalCharges.vue?vue&type=script&lang=js&"
import style0 from "./ExternalCharges.vue?vue&type=style&index=0&id=0a0cdfd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cdfd4",
  null
  
)

export default component.exports